<template>
  <div class="card">

    <div v-if="image" class="card__image">
      <img :src="image">
    </div>

    <div class="card__details">
      <h4>
        <slot name='title'></slot>
      </h4>
      <div class="card__body">
        <slot name='body'></slot>
      </div>
      <a v-if="link" class="card__link" :href="link">Find out more</a>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
        image: {type: String, default: null},
        link: {type: String, default: null},
    }
  }

</script>

<style>

</style>
